import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';

import './Components/ComponentsStyles.css';

import Header from './Components/HeaderComponent';
import HomePage from './Components/HomePageComponent';
import Photogallery from './Components/PhotogalleryComponent';
import ContactPage from './Components/ContactPageComponent';
import DateCalendar from './Components/DateCalendarComponent';
import PriceListPage from './Components/PriceListPageComponent';
import Footer from './Components/FooterComponent';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#0082a2',
    },
    secondary: {
      main: '#ab47bc',
    },
  },
});

function App() {
  const [admin, setAdmin] = useState(null);
  const API = 'https://accommodationdv.herokuapp.com/'

  useEffect(() => {
    if(!localStorage.admin) {
      localStorage.setItem('admin', JSON.stringify({}));
    }
    if (JSON.parse(localStorage.getItem('admin')).username) {
        setAdmin(JSON.parse(localStorage.getItem('admin')));
    }
  }, []);

  const props = {
    admin,
    API
  }

  return (
    <Router>
      <ThemeProvider theme={theme}>
        <div className="App">
          <Header />
          <Route path='/' exact render={() => <HomePage />} />
          <Route path='/photogallery' component={Photogallery} />
          <Route path='/contact' component={ContactPage} />
          <Route path='/calendar' component={DateCalendar} />
          <Route path='/pricelist' render={() => <PriceListPage {...props} />} />
          <Footer {...props} />
        </div>
      </ThemeProvider>
    </Router>
  );
}

export default App;
